var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ylAboutHonorAward"}},[(_vm.isMobileScreen)?_c('ylAboutHonorAwardMobile',_vm._b({},'ylAboutHonorAwardMobile',_vm.$attrs,false)):_c('ylAboutHonorAwardPC',_vm._b({},'ylAboutHonorAwardPC',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }